import React, { useEffect, useState } from 'react';
import Dialog from '@/presentation/reusables/Dialog';
import errorSvg from '../../assets/error.svg';
import successSvg from '../../assets/success.svg';
import { WrapperMessageDialog } from './styled';

import type { TActionState2 } from '../../types';
import maskString from '@/core/utils/maskString';

interface IProps {
  actionState: TActionState2;
  controllerActionState: (state: Partial<TActionState2>) => void;
  isPhone: boolean;
}

const MessageDialog = ({
  actionState,
  controllerActionState,
  // eslint-disable-next-line
  isPhone
}: IProps) => {
  const [isActive, setIsActive] = useState(false);
  const config = {
    DEFAULT: { textButton: undefined, src: '' },
    ERROR: { textButton: 'Volver a intentarlo', src: errorSvg },
    FINISH: { textButton: undefined, src: '' },
    SUCCESS: { textButton: undefined, src: successSvg }
  };

  const defaultType = { title: '', message: '', mask: undefined };
  const types = {
    ERROR: {
      EMAIL: {
        ...defaultType,
        title: 'No se logró registrar la actualización de correo electrónico',
        message: 'Por favor, intentarlo nuevamente'
      },
      PHONE: {
        ...defaultType,
        title: 'No se logró registrar la actualización de tu número de celular',
        message: 'Por favor, intentarlo nuevamente',
        mask: 'XXX XXX XXX'
      },
      DEFAULT: { ...defaultType }
    },
    SUCCESS: {
      EMAIL: {
        ...defaultType,
        title: '¡Tu correo electrónico se validó correctamente!',
        message: 'Se modificó tu correo electrónico'
      },
      PHONE: {
        ...defaultType,
        title: '¡Tu número de celular se validó correctamente!',
        message: 'Se modificó tu número de celular',
        mask: 'XXX XXX XXX'
      },
      DEFAULT: { ...defaultType }
    },
    DEFAULT: {
      EMAIL: { ...defaultType },
      PHONE: { ...defaultType },
      DEFAULT: { ...defaultType }
    },
    FINISH: {
      EMAIL: { ...defaultType },
      PHONE: { ...defaultType },
      DEFAULT: { ...defaultType }
    }
  };

  useEffect(() => {
    const { action } = actionState;
    setIsActive(action === 'MESSAGE');
  }, [actionState]);

  const handlerCancel = () => {
    controllerActionState({
      action: 'DEFAULT',
      code: '',
      input: 'DEFAULT',
      newValue: '',
      oldValue: '',
      status: 'DEFAULT'
    });
  };

  const handlerConfirm = () => {
    controllerActionState({
      action: 'CONFIRM',
      code: '',
      status: 'DEFAULT'
    });
  };

  return (
    <Dialog
      handlerButtonA={handlerConfirm}
      handlerClose={handlerCancel}
      maxWidth="360px"
      show={isActive}
      textButtonA={config[actionState.status].textButton}
      zIndex={1000}
    >
      <WrapperMessageDialog>
        <img src={config[actionState.status].src} alt="mensajes" />
        <p>{types[actionState.status][actionState.input].title}</p>
        <p>{types[actionState.status][actionState.input].message}</p>
        {actionState.status === 'SUCCESS' && (
          <p>
            {maskString(
              actionState.newValue,
              types[actionState.status][actionState.input].mask
            )}
          </p>
        )}
      </WrapperMessageDialog>
    </Dialog>
  );
};

export default MessageDialog;
